import { authenticatedFetch, getApiUri, throwBody } from "@/api/shared.ts";

// TODO: Move and add more
export interface QuizSessionDetailsResponse {
  topicPathwayQuizId: number;
  questions: Array<QuizQuestionResponse>;
}

export interface QuizQuestionResponse {
  questionId: number;
  sequence: number;
  imageURL: string | null;
  explanationA: string | null;
  explanationB: string | null;
  explanationC: string | null;
  explanationD: string | null;
  correctAnswer: number;
  answers: Array<QuizQuestionAnswer>;
}

export interface QuizQuestionPartResponse {
  locale: string | null;
  parentPartId: string | number | null;
  partId: string | number;
  row: number | string | null;
  sequence: number | string | null;
  type: string;
  value: string | null;
}

export interface QuizQuestionWithPartsResponse {
  questionId: number;
  questionParts: Array<QuizQuestionPartResponse>;
}

interface QuizQuestionAnswer {
  answerId: number;
  questionId: number;
  dateAnswered: string;
  answerValue: number;
  reason: string | null;
  isGuess: boolean;
  isCorrect: boolean;
  confidence: number | null;
  dateReviewed: string | null;
}

export const getQuizSessionDetails = async (
  quizSessionId: number,
): Promise<QuizSessionDetailsResponse> => {
  if (quizSessionId === -1) {
    throw new Error("Invalid quiz session id (-1 provided)");
  }

  const response = await authenticatedFetch(getApiUri(`/v3/quiz-sessions/${quizSessionId}`), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw await throwBody(response);
  }

  return response.json();
};

export const getQuizQuestionWithParts = async (
  questionId: number,
): Promise<QuizQuestionWithPartsResponse> => {
  if (questionId <= 0) {
    throw new Error("Question id must be positive");
  }

  const response = await authenticatedFetch(
    getApiUri(`/v3/questions/${questionId}?includes=question-parts`),
    {
      method: "GET",
      priority: "high",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw await throwBody(response);
  }

  return response.json();
};

// It has way more, expand it if you actually need it :)
interface TopicPathwayQuizResponse {
  shortCode: string;
}

export const getTopicPathwayQuiz = async (
  topicPathwayQuizId: number,
): Promise<TopicPathwayQuizResponse> => {
  if (topicPathwayQuizId === -1) {
    throw new Error("Invalid quiz topic pathway id (-1 provided)");
  }

  const response = await authenticatedFetch(
    getApiUri(`/v4/topic-pathway-quizs/${topicPathwayQuizId}?includes=source`),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw await throwBody(response);
  }

  return response.json();
};
